// extracted by mini-css-extract-plugin
export default {"toolbar":"settings-tab_toolbar__KI5f0","soundToggle":"settings-tab_soundToggle__IYQcj"};